import { Image } from 'antd'

export const ImageCanvas = ({ src }: { src: string }) => (
  <Image
    src={src}
    alt=""
    preview={{ src }}
    draggable={false}
    style={{
      maxWidth: '100%',
      maxHeight: '100%',
      width: 'auto',
      height: 'auto',
      objectFit: 'contain',
      display: 'block',
      boxShadow: '0 2px 12px rgba(0, 0, 0, 0.25)',
    }}
  />
)
